// (() => {
//   // ---------- Section Render helpers (drawer refresh) ----------
//   const ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
//   const SECTION_HANDLES =
//     (document.body?.dataset?.vtCartSections || '')
//       .split(',')
//       .map(s => s.trim())
//       .filter(Boolean)
//       || window.VariantTilesCartSections
//       || ['cart-drawer', 'cart-icon-bubble'];

//   const parseHTML = (html) => new DOMParser().parseFromString(html, 'text/html');
//   const fetchCart = () => fetch('/cart.js', { credentials: 'same-origin' }).then(r => r.json());

  
//   async function refreshCartSections() {
//     try {
//       const url = `${ROOT}?sections=${encodeURIComponent(SECTION_HANDLES.join(','))}`;
//       const res = await fetch(url, { credentials: 'same-origin' });
//       if (res.ok) {
//         const json = await res.json();
//         SECTION_HANDLES.forEach(handle => {
//           const html = json[handle];
//           if (!html) return;
//           const doc = parseHTML(html);

//           const pageDrawer = document.querySelector('cart-drawer') || document.querySelector('#CartDrawer') || document.querySelector('[data-cart-drawer]');
//           const newDrawer  = doc.querySelector('cart-drawer') || doc.querySelector('#CartDrawer') || doc.querySelector('[data-cart-drawer]');
//           if (pageDrawer && newDrawer) pageDrawer.innerHTML = newDrawer.innerHTML;

//           const pageCount = document.querySelector('[data-cart-count]') || document.querySelector('.cart-count-bubble') || document.querySelector('.header__cart-count') || document.querySelector('[data-header-cart-count]');
//           const newCount  = doc.querySelector('[data-cart-count]') || doc.querySelector('.cart-count-bubble') || doc.querySelector('.header__cart-count') || doc.querySelector('[data-header-cart-count]');
          
//           if (pageCount && newCount) pageCount.replaceWith(newCount);
//         });
//       }
//     } catch(e){ console.warn('Section refresh fallback:', e); }

//     try {
//       const cart = await fetchCart();
//       document.dispatchEvent(new CustomEvent('cart:refresh', { detail: { cart } }));
//       document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart } }));
//       document.dispatchEvent(new CustomEvent('theme:cart:updated', { detail: { cart } }));

//       const drawer = document.querySelector('cart-drawer') || document.querySelector('cart-notification') || document.querySelector('#CartDrawer') || document.querySelector('[data-cart-drawer]');
//       if (drawer?.open) drawer.open();
//       const toggler = document.querySelector('[data-cart-toggle]') || document.querySelector('[data-drawer-toggle="cart"]') || document.querySelector('.js-drawer-open-cart') || document.querySelector('button[aria-controls="CartDrawer"]');
//       if (toggler) toggler.click();
//     } catch (e) { console.warn('Drawer open failed:', e); }
//   }

//   // ---------- Per-section wiring ----------
//   document.querySelectorAll('[data-vt-actions]').forEach(actions => {
//     const section   = actions.closest('[data-section-id]') || document;
//     const grid      = section.querySelector('[data-variant-tiles]'); // may be null (single-variant)
//     const pricebar  = section.querySelector('[data-vt-pricebar]');
//     const sticky    = section.querySelector('[data-vt-sticky]');
//     const stickySel = sticky?.querySelector('[data-vt-sticky-variant]') || null;

//     // Optional product form (Mode A)
//     const productForm = section.querySelector('product-form form') || section.querySelector('form[action*="/cart/add"]') || null;
//     const idInput     = productForm?.querySelector('input[name="id"], select[name="id"]') || null;

//     let selectedVariantId = actions.dataset.defaultVid || null;

//     // --- Selection helpers ---
//     function updateTopPriceFromTile(tile) {
//       if (!tile || !pricebar) return;
//       const now  = pricebar.querySelector('[data-vt-now]');
//       const was  = pricebar.querySelector('[data-vt-was]');
//       const save = pricebar.querySelector('[data-vt-save]');

//       now.textContent = tile.dataset.price;
//       const compareCents = parseInt(tile.dataset.compareCents || '0', 10);
//       const savingCents  = parseInt(tile.dataset.savingCents  || '0', 10);

//       if (compareCents > 0 && savingCents > 0) {
//         was.style.display = '';
//         was.textContent = tile.dataset.compare;
//         save.style.display = '';
//         save.textContent = `Save ${tile.dataset.saving}`;
//       } else {
//         was.style.display = 'none';
//         save.style.display = 'none';
//       }
//     }

//     function setActiveTileById(vid) {
//       if (!grid) return;
//       grid.querySelectorAll('.variant-tile').forEach(el => {
//         const isActive = el.getAttribute('data-variant-id') === String(vid);
//         el.classList.toggle('is-active', isActive);
//         el.setAttribute('aria-pressed', isActive ? 'true' : 'false');
//         if (isActive) updateTopPriceFromTile(el);
//       });
//     }

//     function selectVariant(vid) {
//       selectedVariantId = String(vid);

//       // Sync theme form
//       if (idInput) {
//         idInput.value = selectedVariantId;
//         idInput.dispatchEvent(new Event('change', { bubbles: true }));
//       }

//       // Sync tiles and top price
//       setActiveTileById(selectedVariantId);

//       // Sync sticky select
//       if (stickySel) stickySel.value = selectedVariantId;
//     }

//     // Initial selection (from tiles or default vid)
//     (function initSelection(){
//       const initialTile = grid?.querySelector('.variant-tile.is-active') || grid?.querySelector('.variant-tile');
//       if (initialTile) {
//         selectedVariantId = initialTile.getAttribute('data-variant-id');
//         updateTopPriceFromTile(initialTile);
//       }
//       if (stickySel && selectedVariantId) stickySel.value = selectedVariantId;
//       if (idInput && selectedVariantId) {
//         idInput.value = selectedVariantId;
//         idInput.dispatchEvent(new Event('change', { bubbles: true }));
//       }
//     })();

//     // Tile click/keyboard
//     if (grid) {
//       grid.addEventListener('click', e => {
//         const tile = e.target.closest('.variant-tile');
//         if (!tile || tile.getAttribute('aria-disabled') === 'true') return;
//         selectVariant(tile.getAttribute('data-variant-id'));
//       });
//       grid.addEventListener('keydown', e => {
//         if ((e.key === 'Enter' || e.key === ' ') && e.target.classList.contains('variant-tile')) {
//           e.preventDefault();
//           const vid = e.target.getAttribute('data-variant-id');
//           if (vid) selectVariant(vid);
//         }
//       });
//     }

//     // Sticky select change
//     stickySel?.addEventListener('change', e => {
//       const vid = e.target.value;
//       if (vid) selectVariant(vid);
//     });

//     // --- Qty + ATC (works for inline + sticky) ---
//     function wireAtc(scope) {
//       if (!scope) return;
//       const qtyInput = scope.querySelector('[data-vt-qty]');
//       const minusBtn = scope.querySelector('[data-vt-minus]');
//       const plusBtn  = scope.querySelector('[data-vt-plus]');
//       const atcBtn   = scope.querySelector('[data-vt-atc]');

//       minusBtn?.addEventListener('click', () => {
//         const current = parseInt(qtyInput.value || '1', 10);
//         qtyInput.value = Math.max(1, current - 1);
//       });
//       plusBtn?.addEventListener('click', () => {
//         const current = parseInt(qtyInput.value || '1', 10);
//         qtyInput.value = current + 1;
//       });

//       atcBtn?.addEventListener('click', async () => {
//         const qty = parseInt(qtyInput?.value || '1', 10);
//         const vid = selectedVariantId || grid?.querySelector('.variant-tile.is-active')?.getAttribute('data-variant-id');
//         if (!vid) return;

//         atcBtn.disabled = true;
//         const prevLabel = atcBtn.textContent;
//         atcBtn.textContent = 'Adding…';

//         // Mode A: keep theme AJAX if product form exists
//         if (productForm && idInput) {
//           let formQty = productForm.querySelector('input[name="quantity"]');
//           if (!formQty) {
//             formQty = document.createElement('input');
//             formQty.type = 'hidden';
//             formQty.name = 'quantity';
//             productForm.appendChild(formQty);
//           }
//           idInput.value = vid;
//           formQty.value = qty;

//           productForm.dispatchEvent(new Event('submit', { bubbles: true }));
//           if (typeof productForm.submit === 'function') productForm.submit();

//           setTimeout(async () => {
//             await refreshCartSections();
//             atcBtn.disabled = false;
//             atcBtn.textContent = prevLabel;
//           }, 250);
//           return;
//         }

//         // Mode B: direct add.js
//         try {
//           const res = await fetch('/cart/add.js', {
//             method: 'POST',
//             credentials: 'same-origin',
//             headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
//             body: JSON.stringify({ id: Number(vid), quantity: qty })
//           });
//           if (!res.ok) {
//             const err = await res.json().catch(() => ({}));
//             throw new Error(err?.description || 'Add to cart failed');
//           }
//           await refreshCartSections();
//         } catch (e) {
//           console.error(e);
//           alert(e.message || 'Could not add to cart');
//         } finally {
//           atcBtn.disabled = false;
//           atcBtn.textContent = prevLabel;
//         }
//       });
//     }

//     wireAtc(actions);
//     wireAtc(sticky);

//     // --- Show sticky ONLY after inline actions pass the TOP of viewport ---
//     if (sticky && actions) {
//       // Optional: set header height once in theme.liquid like:
//       // <body data-vt-sticky-offset="64">
//       const headerOffset = parseInt(document.body.dataset.vtStickyOffset || '0', 10);

//       const updateSticky = () => {
//         const top = actions.getBoundingClientRect().top;
//         // show when the actions' top is above the header line
//         const shouldShow = top <= headerOffset;
//         sticky.classList.toggle('is-visible', shouldShow);
//       };

//       // initialize hidden; then compute on load + scroll/resize
//       sticky.classList.remove('is-visible');
//       updateSticky();
//       window.addEventListener('scroll', updateSticky, { passive: true });
//       window.addEventListener('resize', updateSticky);
//       document.addEventListener('DOMContentLoaded', updateSticky);
//     }
    
//   });
// })();




(() => {
  const ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  const parseHTML = (html) => new DOMParser().parseFromString(html, 'text/html');
  const fetchCart = () => fetch('/cart.js', { credentials: 'same-origin' }).then(r => r.json());

  // ---------------- Refresh Drawer + Bubble ----------------
  async function refreshCartSections() {
    try {
      const url = `${ROOT}?sections=cart-drawer,cart-icon-bubble`;
      const res = await fetch(url, { credentials: 'same-origin' });
      if (res.ok) {
        const json = await res.json();

        // --- Update Drawer ---
        if (json['cart-drawer']) {
          const doc = parseHTML(json['cart-drawer']);
          const newDrawer = doc.querySelector('cart-drawer');
          const pageDrawer = document.querySelector('cart-drawer');
          if (pageDrawer && newDrawer) {
            pageDrawer.innerHTML = newDrawer.innerHTML;
          }
        }

        // --- Update Bubble ---
        if (json['cart-icon-bubble']) {
          const doc = parseHTML(json['cart-icon-bubble']);
          const newBubble = doc.querySelector('#cart-icon-bubble') || doc.querySelector('[data-cart-count]');
          const pageBubble = document.querySelector('#cart-icon-bubble') || document.querySelector('[data-cart-count]');
          if (pageBubble && newBubble) {
            pageBubble.replaceWith(newBubble);
          }
        }
      }
    } catch (e) {
      console.warn('Section refresh failed:', e);
    }

    try {
      const cart = await fetchCart();
      document.dispatchEvent(new CustomEvent('cart:refresh', { detail: { cart } }));
      document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart } }));
      document.dispatchEvent(new CustomEvent('theme:cart:updated', { detail: { cart } }));

      // --- Ensure drawer is visible ---
      const drawer = document.querySelector('cart-drawer');
      if (drawer) drawer.classList.add('is-open');
    } catch (e) {
      console.warn('Drawer open failed:', e);
    }
  }

// Cart drawer open after add to cart is click - START 
  async function openCartDrawer() {
  const drawer = document.querySelector('cart-drawer');
  const overlay = document.getElementById('CartDrawer-Overlay');

  if (!drawer || !overlay) return;

  // Ensure classes for animation & visibility
  drawer.classList.add('active', 'animate');
  drawer.classList.remove('is-empty'); // remove if cart has items
  overlay.style.display = 'block';

  // Optional: focus drawer for accessibility
  const inner = drawer.querySelector('.drawer__inner');
  if (inner) inner.focus({ preventScroll: true });

  // Dispatch theme event if theme listens for it
  document.dispatchEvent(new CustomEvent('theme:cart:opened'));
}
// Cart drawer open after add to cart is click - END

  // ---------------- Per-section wiring ----------------
  document.querySelectorAll('[data-vt-actions]').forEach(actions => {
    const section   = actions.closest('[data-section-id]') || document;
    const grid      = section.querySelector('[data-variant-tiles]'); 
    const pricebar  = section.querySelector('[data-vt-pricebar]');
    const sticky    = section.querySelector('[data-vt-sticky]');
    const stickySel = sticky?.querySelector('[data-vt-sticky-variant]') || null;

    let selectedVariantId = actions.dataset.defaultVid || null;

    // ---------- Helpers ----------
    function updateTopPriceFromTile(tile) {
      if (!tile || !pricebar) return;
      const now  = pricebar.querySelector('[data-vt-now]');
      const was  = pricebar.querySelector('[data-vt-was]');
      const save = pricebar.querySelector('[data-vt-save]');

      now.textContent = tile.dataset.price;
      const compareCents = parseInt(tile.dataset.compareCents || '0', 10);
      const savingCents  = parseInt(tile.dataset.savingCents  || '0', 10);

      if (compareCents > 0 && savingCents > 0) {
        was.style.display = '';
        was.textContent = tile.dataset.compare;
        save.style.display = '';
        save.textContent = `Save ${tile.dataset.saving}`;
      } else {
        was.style.display = 'none';
        save.style.display = 'none';
      }
    }

    function setActiveTileById(vid) {
      if (!grid) return;
      grid.querySelectorAll('.variant-tile').forEach(el => {
        const isActive = el.getAttribute('data-variant-id') === String(vid);
        el.classList.toggle('is-active', isActive);
        el.setAttribute('aria-pressed', isActive ? 'true' : 'false');
        if (isActive) updateTopPriceFromTile(el);
      });
    }

    function selectVariant(vid) {
      selectedVariantId = String(vid);
      setActiveTileById(selectedVariantId);
      if (stickySel) stickySel.value = selectedVariantId;
    }

    // ---------- Init selection ----------
    (function initSelection(){
      const initialTile = grid?.querySelector('.variant-tile.is-active') || grid?.querySelector('.variant-tile');
      if (initialTile) {
        selectedVariantId = initialTile.getAttribute('data-variant-id');
        updateTopPriceFromTile(initialTile);
      }
      if (stickySel && selectedVariantId) stickySel.value = selectedVariantId;
    })();

    // Tile click
    if (grid) {
      grid.addEventListener('click', e => {
        const tile = e.target.closest('.variant-tile');
        if (!tile || tile.getAttribute('aria-disabled') === 'true') return;
        selectVariant(tile.getAttribute('data-variant-id'));
      });
    }

    // Sticky select
    stickySel?.addEventListener('change', e => {
      const vid = e.target.value;
      if (vid) selectVariant(vid);
    });

    // ---------- Qty + ATC ----------
    function wireAtc(scope) {
      if (!scope) return;
      const qtyInput = scope.querySelector('[data-vt-qty]');
      const minusBtn = scope.querySelector('[data-vt-minus]');
      const plusBtn  = scope.querySelector('[data-vt-plus]');
      const atcBtn   = scope.querySelector('[data-vt-atc]');

      minusBtn?.addEventListener('click', () => {
        const current = parseInt(qtyInput.value || '1', 10);
        qtyInput.value = Math.max(1, current - 1);
      });
      plusBtn?.addEventListener('click', () => {
        const current = parseInt(qtyInput.value || '1', 10);
        qtyInput.value = current + 1;
      });

      
      //  Update the cart bubble count by- START
      atcBtn?.addEventListener('click', async () => {
        const qty = parseInt(qtyInput?.value || '1', 10);
        const vid = selectedVariantId || grid?.querySelector('.variant-tile.is-active')?.getAttribute('data-variant-id');
        if (!vid) return;
        atcBtn.disabled = true;
        const prevLabel = atcBtn.textContent;
        atcBtn.textContent = 'Adding…';
        try {
          const res = await fetch('/cart/add.js', {
            method: 'POST',
            credentials: 'same-origin',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({ id: Number(vid), quantity: qty })
          });
          if (!res.ok) {
            const err = await res.json().catch(() => ({}));
            throw new Error(err?.description || 'Add to cart failed');
          }

          // Refresh cart drawer and bubble
          await refreshCartSections();

          // Open cartdrawer after add to cart button clicks
          await openCartDrawer();

          // Open drawer using theme event
          // document.dispatchEvent(new CustomEvent('cart:open'));

          // Update cart bubble manually in case AJAX snippet fails
          const cart = await fetch('/cart.js').then(r => r.json());
          const bubble = document.getElementById('cart-icon-bubble');
          if (bubble) bubble.textContent = cart.item_count;

          // Ensure drawer is open
          const drawer = document.querySelector('cart-drawer');
          if (drawer) drawer.classList.add('is-open');
        } catch (e) {
          console.error(e);
          alert(e.message || 'Could not add to cart');
        } finally {
          atcBtn.disabled = false;
          atcBtn.textContent = prevLabel;
        }
      });
// Need to update the cart bubble count - END 

    }

    wireAtc(actions);
    wireAtc(sticky);

    // Sticky show/hide
    if (sticky && actions) {
      const headerOffset = parseInt(document.body.dataset.vtStickyOffset || '0', 10);
      const updateSticky = () => {
        const top = actions.getBoundingClientRect().top;
        const shouldShow = top <= headerOffset;
        sticky.classList.toggle('is-visible', shouldShow);
      };
      sticky.classList.remove('is-visible');
      updateSticky();
      window.addEventListener('scroll', updateSticky, { passive: true });
      window.addEventListener('resize', updateSticky);
      document.addEventListener('DOMContentLoaded', updateSticky);
    }
  });
})();





